import {Facebook, Youtube, Instagram} from 'lucide-react';

export default function Footer() {
  return (
    <footer className="w-full">
      {/* Seção superior — Fundo azul marinho */}
      <div className="bg-[#0B1437] text-white pt-14 pb-10 px-6 md:px-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Fale Conosco */}
          <div>
            <h3 className="font-bold text-lg mb-4 font-['Bitter',serif]">Fale Conosco</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              (27) 9 9879-7619
            </p>
            <p className="text-gray-300 text-sm leading-relaxed">
              (27) 9 9713-9118
            </p>
          </div>

          {/* Parcerias */}
          <div>
            <h3 className="font-bold text-lg mb-4 font-['Bitter',serif]">Parcerias</h3>
            <a
              href="mailto:comercial@englishwork.com.br"
              className="text-gray-300 text-sm hover:text-white transition-colors">

              comercial@englishwork.com.br
            </a>
          </div>

          {/* Atendimento */}
          <div>
            <h3 className="font-bold text-lg mb-4 font-['Bitter',serif]">Atendimento</h3>
            <a
              href="mailto:atendimento@englishwork.com.br"
              className="text-gray-300 text-sm hover:text-white transition-colors">

              atendimento@englishwork.com.br
            </a>
          </div>

          {/* Redes Sociais */}
          <div>
            <h3 className="font-bold text-lg mb-4 font-['Bitter',serif]">Redes Sociais</h3>
            <div className="flex items-center gap-3 mb-5">
              <a
                href="https://www.facebook.com/profile.php?id=100089366183716"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">

                <Facebook className="w-5 h-5 text-white" />
              </a>
              <a
                href="https://www.youtube.com/@englishwork"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">

                <Youtube className="w-5 h-5 text-white" />
              </a>
              <a
                href="https://www.instagram.com/englishwork_br/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">

                <Instagram className="w-5 h-5 text-white" />
              </a>
            </div>
            {/* Badges de app */}
            <div className="flex flex-col gap-2">
              <a href="https://play.google.com/store/apps/details?id=com.ewpass.mobile&hl=pt_BR" target="_blank" rel="noopener noreferrer" className="inline-block w-40 hover:opacity-80 transition-opacity">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Disponível no Google Play"
                  className="w-full h-auto" />

              </a>
              <a href="https://apps.apple.com/br/app/ew-pass/id6752664261" target="_blank" rel="noopener noreferrer" className="inline-block w-40 hover:opacity-80 transition-opacity">
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Disponível na App Store"
                  className="w-full h-auto" />

              </a>
            </div>
          </div>
        </div>

        {/* Linha divisória verde/azul */}
        <div className="max-w-6xl mx-auto mt-10">
          <div className="h-[2px] bg-gradient-to-r from-emerald-400 via-blue-500 to-indigo-600 rounded-full" />
        </div>
      </div>

      {/* Seção inferior — Fundo escuro */}
      <div className="bg-[#0A0F1E] text-gray-400 py-8 px-6 md:px-16">
        <div className="max-w-6xl mx-auto">
          {/* Selos e certificados */}
          

























          {/* Aviso de garantia */}
          <p className="text-center text-xs text-gray-500 mb-4 max-w-4xl mx-auto leading-relaxed">
            *para garantia de reembolso por não evoluir do nível básico para intermediário ou avançado em até 6 meses, consultar Termos De Uso no site
          </p>

          {/* Copyright */}
          <p className="text-center text-xs text-gray-500">
            English Work Sociedade de Ensino Ltda &copy; {new Date().getFullYear()} - Todos os direitos reservados | CNPJ: 48.620.557/0001-51<br />Rua João Pessoa de Mattos, 530. CEP 29101-115
          </p>
        </div>
      </div>
    </footer>);

}